import React, { useState } from "react";
import { ImgUrl, ApiService } from "../services";
import { TableContainer } from "@material-ui/core";
import { Edit, Delete } from "@material-ui/icons";
import {
  Table,
  TableBody,
  TableRow,
  TableRowData,
  TableHead,
  TableHeader,
} from "../styledComponents/tableStyle";
import GConfirmDialog from "../gComponents/gConfirmDialog";
import GButton from "../gComponents/gButton";
import ZipCodeForm from "../forms/zipCodeForm";
import { useSnackbar } from "react-simple-snackbar";
import useDataFctory from "../useDataFactory";
import GText from "../gComponents/gText";
import Modal from "react-modal";
import GSwitch from "../gComponents/gSwitch";
import { useEffect } from "react";
import GPagination from "../gComponents/gPagination";
import { GSearch } from "../gComponents/gSearch";

const columns = [
  { id: "zipcode", label: "Zipcode", minWidth: 80 },
  { id: "market_name", label: "Market Name", minWidth: 120, align: "center" },
  { id: "team_id", label: "Team ID", minWidth: 80, align: "center" },
  { id: "pickup", label: "Pickup", minWidth: 80, align: "center" },
  { id: "dropoff", label: "Dropoff", minWidth: 120, align: "center" },
  { id: "actions", label: "Actions", minWidth: 60, align: "center" },
];

export default function ZipCodes(props) {
  const [openSnackbar] = useSnackbar();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedZipcodeData, setSelectedZipcodeData] = useState({});
  const [selectedZipcodeId, setSelectedZipcodeId] = useState("");
  const [zcvisible, setZcvisible] = React.useState(false);
  const [isEmpty, setIsEmpty] = useState(true);
  const [filters, setFilters] = useState({
    page: 1,
    search:""
  });
  const {
    loading,
    data: zipcodesData,
    Placeholder,
    TableShimmer,
    pagination,
    refreshData,
  } = useDataFctory("zipcodes", true, {
    order: "DESC",
    orderby: "id",
    page: filters.page || 1, search:filters.search||""
  });

  useEffect(() => {
    refreshData({
      order: "DESC",
      orderby: "id",
      page: filters.page || 1,
      search:filters.search||""
    });
  }, [filters]);

  const handleChangePage = (pageUrl) => {
    console.log(pageUrl);
    var NewPageNo = pageUrl.substr(pageUrl.lastIndexOf("=") + 1);
    setFilters({ ...filters, page: NewPageNo });
  };

  const handleSwitchValue = (val, id, key) => {
    let obj = {};
    let selectedIndex = zipcodesData.findIndex((p) => p.id == id);
    if (selectedIndex >= 0) {
      zipcodesData[selectedIndex][key] = val;
      obj = { ...zipcodesData[selectedIndex] };
      delete obj.id;
    }
    console.log(obj);
    ApiService({
      method: "PUT",
      route: "zipcodes/" + id,
      body: obj,
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.status_code === 1) {
        } else {
          let selectedIndex = zipcodesData.findIndex((p) => p.id == id);
          if (selectedIndex > -1) {
            zipcodesData[selectedIndex][key] =
              zipcodesData[selectedIndex][key] == 1 ? 0 : 1;
          }
        }
        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteZipcode = () => {
    ApiService({
      method: "DELETE",
      route: "zipcodes/" + selectedZipcodeId,
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.status_code === 1) {
          let selectedIndex = zipcodesData.findIndex(
            (p) => p.id == selectedZipcodeId
          );
          if (selectedIndex > -1) {
            zipcodesData.splice(selectedIndex, 1);
          }
        }
        openSnackbar(response.data.message);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="rightInnerView">
      <GButton
        variant="condensed"
        children="Add"
        onClick={() => {
          setSelectedZipcodeData({});
          setIsEmpty(true);
          setZcvisible(true);
        }}
        style={{
          float: "right",
          marginTop: "5px",
        }}
      />
      <GText g2 bold text={"Zip Codes"} style={{ marginBottom: "15px" }} />

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          marginBottom: "5px",
          gap: "10px",
        }}
      >
         <GSearch
          placeholder="Search ..."
          value={filters.search}
          handleChange={(val) =>
            setFilters({ ...filters, search: val, page: 1 })
          }
          isDebounce={true}
        />
        <GPagination
          style={{ marginLeft: "auto" }}
          count={pagination.total}
          from={pagination.from}
          to={pagination.to}
          onChangeNextPage={() => handleChangePage(pagination.next_page_url)}
          onChangePrevPage={() => handleChangePage(pagination.prev_page_url)}
          rowsPerPage={pagination.per_page}
          prevDisabled={pagination.prev_page_url ? false : true}
          nextDisabled={pagination.next_page_url ? false : true}
        ></GPagination>
      </div>
      <div className="listPaper">
        {loading === true ? (
          <TableShimmer />
        ) : zipcodesData && zipcodesData.length > 0 ? (
          <TableContainer>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableHeader
                      key={column.id}
                      style={{
                        minWidth: column.minWidth,
                        textAlign: column.align,
                      }}
                    >
                      {column.label}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {zipcodesData.map((c) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={c.id}>
                      <TableRowData
                        style={{ BorderBottom: "1px solid #f4f5f9" }}
                      >
                        {c.zipcode}
                      </TableRowData>
                      <TableRowData
                        style={{
                          BorderBottom: "1px solid #f4f5f9",
                          textAlign: "center",
                        }}
                      >
                        {c.market_name || "-"}
                      </TableRowData>
                      <TableRowData
                        style={{
                          BorderBottom: "1px solid #f4f5f9",
                          textAlign: "center",
                        }}
                      >
                        {c.team_id || "-"}
                      </TableRowData>
                      <TableRowData style={{ textAlign: "center" }}>
                        <GSwitch
                          id={"pickup" + c.id}
                          uId={c.id}
                          currentValue={c.is_pickup}
                          onSwitchChange={(newvalue) =>
                            handleSwitchValue(newvalue, c.id, "is_pickup")
                          }
                          style={{ display: "inline-block" }}
                        />
                      </TableRowData>
                      <TableRowData style={{ textAlign: "center" }}>
                        <GSwitch
                          id={"dropoff" + c.id}
                          uId={c.id}
                          currentValue={c.is_dropoff}
                          onSwitchChange={(newvalue) =>
                            handleSwitchValue(newvalue, c.id, "is_dropoff")
                          }
                          style={{ display: "inline-block" }}
                        />
                      </TableRowData>
                      <TableRowData
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <GButton
                          variant="linkable"
                          onClick={(e) => {
                            setSelectedZipcodeData(c);
                            setIsEmpty(false);
                            setZcvisible(true);
                          }}
                        >
                          <Edit fontSize="small" />
                        </GButton>
                        <GButton
                          variant="linkable"
                          onClick={(e) => {
                            setSelectedZipcodeId(c.id);
                            setDialogOpen(true);
                          }}
                        >
                          <Delete fontSize="small" />
                        </GButton>
                      </TableRowData>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Placeholder />
        )}
      </div>

      {dialogOpen === true && (
        <GConfirmDialog
          open={dialogOpen}
          title="Delete Zip Code"
          text="Are you sure you want to delete this zip code?"
          handleClose={() => setDialogOpen(false)}
          onConfirmClose={() => {
            setDialogOpen(false);
            deleteZipcode();
          }}
        ></GConfirmDialog>
      )}

      <Modal
        isOpen={zcvisible}
        className="modal modalRight"
        overlayClassName="modal-overlay"
        onRequestClose={() => setZcvisible(false)}
        style={{
          content: {
            width: "420px",
          },
        }}
        contentLabel="Zipcode Form Modal"
      >
        <ZipCodeForm
          zcvisible={zcvisible}
          setZcvisible={setZcvisible}
          data={selectedZipcodeData}
          isEmpty={isEmpty}
          onSubmit={(data) => {
            let selectedIndex = zipcodesData.findIndex((p) => p.id == data.id);
            if (selectedIndex > -1) {
              zipcodesData[selectedIndex] = { ...data };
            } else {
              refreshData({
                order: "DESC",
                orderby: "id",
                page: filters.page || 1,
              });
            }
          }}
        />
      </Modal>
    </div>
  );
}
